import { useMemo } from "react";
import type * as type from "@vTypes";
import type { ShiftLookupMaps } from "@/utils/shift-util";
import type { ShiftReturnType } from "@/hooks/roster-craete/useShiftsQuery";
import {
  createShiftCatalog,
  type ShiftCatalog,
  type ShiftCatalogShift,
} from "@/services/shift/shiftCatalog";

/**
 * `availableShifts`와 `/shifts` 응답을 id 기준 병합 후 `buildShiftLookupMaps`.
 * Roster_create `TableBody_base`와 동일 패턴: `{ lookupMaps }` 만 반환.
 */
export function useShiftLookupMaps(
  defaultShiftCode: type.availableShifts[],
  shiftsData: ShiftReturnType | undefined | null
): {
  lookupMaps: ShiftLookupMaps<ShiftCatalogShift>;
  catalog: ShiftCatalog;
} {
  return useMemo(() => {
    const catalog = createShiftCatalog(defaultShiftCode, shiftsData);
    return { lookupMaps: catalog.lookupMaps, catalog };
  }, [defaultShiftCode, shiftsData]);
}
